import React, { useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { ValidatedField, ValidatedForm } from 'react-jhipster';
import { Link, useNavigate, useParams } from 'react-router';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';

import { createEntity, getEntity, reset, updateEntity } from './callback.reducer';

export const CallbackUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const callbackEntity = useAppSelector(state => state.callback.entity);
  const loading = useAppSelector(state => state.callback.loading);
  const updating = useAppSelector(state => state.callback.updating);
  const updateSuccess = useAppSelector(state => state.callback.updateSuccess);

  const handleClose = () => {
    navigate(`/callback${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    values.horaEnvioMensaje = convertDateTimeToServer(values.horaEnvioMensaje);
    values.horaProcMensajeCobro = convertDateTimeToServer(values.horaProcMensajeCobro);
    values.horaSolicitudMensajeCobro = convertDateTimeToServer(values.horaSolicitudMensajeCobro);
    if (values.monto !== undefined && typeof values.monto !== 'number') {
      values.monto = Number(values.monto);
    }
    if (values.resultadoMensajeCobro !== undefined && typeof values.resultadoMensajeCobro !== 'number') {
      values.resultadoMensajeCobro = Number(values.resultadoMensajeCobro);
    }
    if (values.tipoCuentaCliente !== undefined && typeof values.tipoCuentaCliente !== 'number') {
      values.tipoCuentaCliente = Number(values.tipoCuentaCliente);
    }
    values.timestampRecibido = convertDateTimeToServer(values.timestampRecibido);
    values.createdDate = convertDateTimeToServer(values.createdDate);

    const entity = {
      ...callbackEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          horaEnvioMensaje: displayDefaultDateTime(),
          horaProcMensajeCobro: displayDefaultDateTime(),
          horaSolicitudMensajeCobro: displayDefaultDateTime(),
          timestampRecibido: displayDefaultDateTime(),
          createdDate: displayDefaultDateTime(),
        }
      : {
          ...callbackEntity,
          horaEnvioMensaje: convertDateTimeFromServer(callbackEntity.horaEnvioMensaje),
          horaProcMensajeCobro: convertDateTimeFromServer(callbackEntity.horaProcMensajeCobro),
          horaSolicitudMensajeCobro: convertDateTimeFromServer(callbackEntity.horaSolicitudMensajeCobro),
          timestampRecibido: convertDateTimeFromServer(callbackEntity.timestampRecibido),
          createdDate: convertDateTimeFromServer(callbackEntity.createdDate),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tupago1App.callback.home.createOrEditLabel" data-cy="CallbackCreateUpdateHeading">
            Create or edit a Callback
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew && <ValidatedField name="id" required readOnly id="callback-id" label="ID" validate={{ required: true }} />}
              <ValidatedField
                label="Celular Cliente"
                id="callback-celularCliente"
                name="celularCliente"
                data-cy="celularCliente"
                type="text"
                validate={{
                  maxLength: { value: 20, message: 'This field cannot be longer than 20 characters.' },
                }}
              />
              <ValidatedField
                label="Cert Bde M"
                id="callback-certBdeM"
                name="certBdeM"
                data-cy="certBdeM"
                type="text"
                validate={{
                  minLength: { value: 20, message: 'This field is required to be at least 20 characters.' },
                  maxLength: { value: 20, message: 'This field cannot be longer than 20 characters.' },
                }}
              />
              <ValidatedField
                label="Cert Comercio Proveedor"
                id="callback-certComercioProveedor"
                name="certComercioProveedor"
                data-cy="certComercioProveedor"
                type="text"
                validate={{
                  minLength: { value: 20, message: 'This field is required to be at least 20 characters.' },
                  maxLength: { value: 20, message: 'This field cannot be longer than 20 characters.' },
                }}
              />
              <ValidatedField
                label="Clave Institucion Cliente"
                id="callback-claveInstitucionCliente"
                name="claveInstitucionCliente"
                data-cy="claveInstitucionCliente"
                type="text"
                validate={{
                  minLength: { value: 5, message: 'This field is required to be at least 5 characters.' },
                  maxLength: { value: 5, message: 'This field cannot be longer than 5 characters.' },
                }}
              />
              <ValidatedField
                label="Clave Rastreo"
                id="callback-claveRastreo"
                name="claveRastreo"
                data-cy="claveRastreo"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Concepto"
                id="callback-concepto"
                name="concepto"
                data-cy="concepto"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Digito Verificador Cliente"
                id="callback-digitoVerificadorCliente"
                name="digitoVerificadorCliente"
                data-cy="digitoVerificadorCliente"
                type="text"
                validate={{
                  maxLength: { value: 3, message: 'This field cannot be longer than 3 characters.' },
                }}
              />
              <ValidatedField
                label="Hora Envio Mensaje"
                id="callback-horaEnvioMensaje"
                name="horaEnvioMensaje"
                data-cy="horaEnvioMensaje"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label="Hora Proc Mensaje Cobro"
                id="callback-horaProcMensajeCobro"
                name="horaProcMensajeCobro"
                data-cy="horaProcMensajeCobro"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label="Hora Solicitud Mensaje Cobro"
                id="callback-horaSolicitudMensajeCobro"
                name="horaSolicitudMensajeCobro"
                data-cy="horaSolicitudMensajeCobro"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label="Id Mensaje Cobro"
                id="callback-idMensajeCobro"
                name="idMensajeCobro"
                data-cy="idMensajeCobro"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField label="Monto" id="callback-monto" name="monto" data-cy="monto" type="text" />
              <ValidatedField
                label="Nombre Cliente"
                id="callback-nombreCliente"
                name="nombreCliente"
                data-cy="nombreCliente"
                type="text"
                validate={{
                  maxLength: { value: 40, message: 'This field cannot be longer than 40 characters.' },
                }}
              />
              <ValidatedField
                label="Numero Cuenta Cliente"
                id="callback-numeroCuentaCliente"
                name="numeroCuentaCliente"
                data-cy="numeroCuentaCliente"
                type="text"
                validate={{
                  maxLength: { value: 20, message: 'This field cannot be longer than 20 characters.' },
                }}
              />
              <ValidatedField
                label="Resultado Mensaje Cobro"
                id="callback-resultadoMensajeCobro"
                name="resultadoMensajeCobro"
                data-cy="resultadoMensajeCobro"
                type="text"
              />
              <ValidatedField
                label="Tipo Cuenta Cliente"
                id="callback-tipoCuentaCliente"
                name="tipoCuentaCliente"
                data-cy="tipoCuentaCliente"
                type="text"
              />
              <ValidatedField
                label="Sello Digital"
                id="callback-selloDigital"
                name="selloDigital"
                data-cy="selloDigital"
                type="text"
                validate={{
                  maxLength: { value: 500, message: 'This field cannot be longer than 500 characters.' },
                }}
              />
              <ValidatedField
                label="Timestamp Recibido"
                id="callback-timestampRecibido"
                name="timestampRecibido"
                data-cy="timestampRecibido"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label="Extra 1"
                id="callback-extra1"
                name="extra1"
                data-cy="extra1"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 2"
                id="callback-extra2"
                name="extra2"
                data-cy="extra2"
                type="text"
                validate={{
                  maxLength: { value: 1000, message: 'This field cannot be longer than 1000 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 3"
                id="callback-extra3"
                name="extra3"
                data-cy="extra3"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 4"
                id="callback-extra4"
                name="extra4"
                data-cy="extra4"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 5"
                id="callback-extra5"
                name="extra5"
                data-cy="extra5"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 6"
                id="callback-extra6"
                name="extra6"
                data-cy="extra6"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 7"
                id="callback-extra7"
                name="extra7"
                data-cy="extra7"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 8"
                id="callback-extra8"
                name="extra8"
                data-cy="extra8"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 9"
                id="callback-extra9"
                name="extra9"
                data-cy="extra9"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 10"
                id="callback-extra10"
                name="extra10"
                data-cy="extra10"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Created Date"
                id="callback-createdDate"
                name="createdDate"
                data-cy="createdDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <Button as={Link as any} id="cancel-save" data-cy="entityCreateCancelButton" to="/callback" replace variant="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button variant="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CallbackUpdate;
